import React from 'react'
// to be completed
function EmailSignUpModal() {
  return <div className="email-sign-up-modal"></div>
}

export default EmailSignUpModal
